import React from "react";
import "./styles.scss";
import { STEPS } from "./helper";
import rr_logo from "../../../assets/images/logo.png";
import sunroofLogo from "../../../assets/images/sunroof-logo.svg";

const TopBar = ({ step, mediaQuery, roofType }) => {
  const stepCount = roofType === "solar" ? 6 : 5;
  return (
    <>
      <div
        className={
          roofType === "solar"
            ? "top-bar-section solar-top-padding"
            : "top-bar-section"
        }
      >
        <div className="logo-container">
          {" "}
          <a target="__blank" href="https://www.remoteroofing.com">
            <img
              src={roofType === "solar" ? sunroofLogo : rr_logo}
              alt="Logo"
              className={
                step === stepCount && mediaQuery === "isDesktop"
                  ? `${roofType === "solar" ? "sunroof-logo" : ""} rr-logo mt-5`
                  : `${roofType === "solar" ? "sunroof-logo" : ""} rr-logo`
              }
            />
          </a>{" "}
        </div>
        {step <= stepCount && (
          <>
            <div className={`stepper-container`}>
              {(roofType === "solar" && step < 6) || step <= 5 ? (
                <img
                  src={
                    mediaQuery === "isMobile"
                      ? STEPS[roofType === "solar" ? "SOLAR" : "REST"].mobile[
                          step
                        ]
                      : STEPS[roofType === "solar" ? "SOLAR" : "REST"].desktop[
                          step
                        ]
                  }
                  alt="Step Indicator"
                  className={`stepper-img ${
                    mediaQuery === "isDesktop" &&
                    roofType === "solar" &&
                    "solar-desktop-stepper"
                  }`}
                />
              ) : null}
            </div>
            <span>
              {step === 6 ? (
                <>
                  <a href="">Call us</a>
                </>
              ) : (
                `${step + 1}/${stepCount}`
              )}
            </span>
          </>
        )}
      </div>
    </>
  );
};

export default TopBar;
